import React, { useState, useEffect, useContext, useRef } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	Dialog,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	Divider
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '../../../theme';
import { isEmpty, isUndefined } from 'lodash';

import { useParams } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';

import { getRol, getToken, getUser } from '../../../api/Account';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import NoData from '../../../components/NoData';
import { getRecuperacionAsync } from '../../../api/Report';
import { PrintReport } from '../../../components/PrintReport';
import moment from 'moment';
import {
	getGestoresAsync,
	getGestoresBySucursalAccessAsync,
	getSucursalByUserAsync,
	getUsersPayedBySucursalAccessAsync
} from '../../../api/Users';
import { formatCurrency, isAccess, simpleMessage } from '../../../helpers/Helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx/xlsx.mjs';

const Recuperacion = () => {
	const [data, setData] = useState([]);

	const [sucursalName, setSucursalName] = useState('');
	const [sucursalList, setSucursalList] = useState([]);

	const [gestorName, setGestorName] = useState('');
	const [gestorList, setGestorList] = useState([]);

	const compRef = useRef();
	const { selectedSucursal, fechaDesde, fechaHasta, selectedGestor } = useParams();

	const { setIsLoading, setIsUnautorized, title, slogan, icon, access } = useContext(DataContext);

	const token = getToken();
	const user = getUser();
	const rol = getRol();

	useEffect(() => {
		(async () => {
			let sucursals = await getSucursals();

			if (selectedSucursal === '0') {
				setSucursalName('Todas');
			} else {
				let name = sucursals.filter((item) => item.id.toString() === selectedSucursal);
				setSucursalName(name[0].description);
			}

			const data = {
				desde: fechaDesde.toString(),
				hasta: fechaHasta.toString(),
				gestorId: selectedGestor === 't' ? 0 : selectedGestor,
				sucursalId: selectedSucursal === 't' ? 0 : selectedSucursal
			};

			setIsLoading(true);
			const result = await getRecuperacionAsync(token, data);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setIsLoading(false);

			setData(result.data.result);
		})();
	}, []);

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(
			selectedSucursal === '0'
				? result.data.result
				: result.data.result.filter((g) => g.id.toString() === selectedSucursal)
		);

		let gestores = await getGestores(selectedSucursal);

		if (selectedGestor === 't') {
			setGestorName('Todos');
		} else {
			let name = gestores.filter((item) => item.id.toString() === selectedGestor);

			setGestorName(name[0].fullName);
		}
		return result.data.result;
	};

	const getGestores = async (sucursal) => {
		setIsLoading(true);
		const data = {
			desde: moment(fechaDesde).format('YYYY-MM-DD'),
			hasta: moment(fechaHasta).format('YYYY-MM-DD'),
			sucursal: selectedSucursal === 't' ? 0 : selectedSucursal
		};
		const result = await getUsersPayedBySucursalAccessAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);
		setGestorList(result.data.result);
		return result.data.result;
	};

	const pageStyle = `
  @media print {
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media all {
    .pagebreak {
      display: none;
    }
  }
  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }  
  @page { size: letter landscape; margin: 4mm; }
`;

	let totalCobrosConsol = 0;
	let totalCapConsol = 0;
	let totalICConsol = 0;
	let totalSeguroConsol = 0;
	let totalCobradoConsol = 0;

	let totalDiaConsol = 0;
	let totalAdelantoConsol = 0;

	const exportExcel = () => {
		let exp = [];
		data.map((item) => {
			const dataGestor = gestorList.filter((gestor) => gestor.id === item.gestor);
			let gestor = dataGestor[0];
			let obj = {
				transaccion: item.id,
				cliente: item.cliente,
				creditoId: item.creditId,
				fechaHoraPago: moment(item.fechaPago).format('DD/MM/yyyy hh:mm'),
				...(isAccess(access, 'VER DETALLE RECUPERACION') && {
					AbonoCapital: item.aCapital,
					abonoInteres: item.aIntCorriente
					// abonoSeguro: (item.aIntCorriente / 100) * 1,
				}),
				totalRecibido: item.totalRecibido,
				gestor: isUndefined(gestor) ? item.gestor : gestor.fullName,
				sucursal: item.sucursal
			};
			exp.push(obj);
		});
		var bk = XLSX.utils.book_new(),
			bs = XLSX.utils.json_to_sheet(exp);

		XLSX.utils.book_append_sheet(bk, bs, 'recuperacion');
		XLSX.writeFile(bk, 'Recuperacion.xlsx');
	};

	return (
		<div>
			<Dialog fullScreen open={true}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
						<Typography
							sx={{ ml: 2, flex: 1, textAlign: 'center' }}
							variant="h5"
							component="div"
						>
							{`${title} `}
						</Typography>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
					</Toolbar>
				</AppBar>

				<Stack display="flex" justifyContent="center">
					<Stack
						direction={'row'}
						justifyContent="space-between"
						paddingLeft={5}
						paddingRight={5}
						marginTop={1}
						marginBottom={1}
					>
						<IconButton variant="outlined" onClick={() => exportExcel()}>
							<FontAwesomeIcon
								icon={faCloudArrowDown}
								style={{ fontSize: 40, color: '#00a152', width: 40 }}
							/>
						</IconButton>

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
							>
								{slogan}
							</Typography>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
								variant="h6"
								component="div"
							>
								Reporte de Recuperación
							</Typography>
						</Stack>

						<ReactToPrint
							trigger={() => {
								return (
									<IconButton
										variant="outlined"
										// style={{ position: "fixed", right: 20, top: 75 }}
									>
										<PrintRoundedIcon
											style={{
												fontSize: 40,
												color: '#2979ff',
												width: 40
											}}
										/>
									</IconButton>
								);
							}}
							content={() => compRef.current}
							pageStyle={pageStyle}
						/>
					</Stack>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="space-between">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Parametros:
								</Typography>

								<Typography fontSize={11} textAlign="left">
									{`Sucursal: ${
										selectedSucursal === 't' ? 'Todas' : sucursalName
									}`}
								</Typography>

								<Typography fontSize={11} textAlign="left">
									{`Gestor Seleccionado: ${
										selectedGestor === 't' ? 'Todos' : gestorName
									}`}
								</Typography>

								<Typography fontSize={11} textAlign="left">
									{`Desde: ${moment(fechaDesde).format('L')} - Hasta:  ${moment(
										fechaHasta
									).format('L')}`}
								</Typography>
							</Stack>

							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{rol}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</Stack>

				<Container maxWidth={false} sx={{ textAlign: 'center' }}>
					<hr />
					{isEmpty(data) ? (
						<NoData />
					) : (
						<>
							{sucursalList.map((suc) => {
								const sSucursal = data.filter(
									(c) => c.sucursal === suc.description
								);
								return (
									<Stack key={suc.description}>
										<Stack direction="row" spacing={1}>
											<Typography
												sx={{
													color: '#2196f3',
													textAlign: 'left'
												}}
												fontSize={11}
											>
												Sucursal:
											</Typography>
											<Typography
												sx={{
													textAlign: 'left'
												}}
												fontSize={11}
											>
												{`${suc.description}`}
											</Typography>
										</Stack>

										{gestorList.map((gestor) => {
											const cGestor = sSucursal.filter(
												(c) => c.gestor === gestor.id
											);
											let totalCap = 0;
											let totalIC = 0;
											let totalSeguro = 0;
											let totalCobrado = 0;

											let totalDia = 0;
											let totalAdelanto = 0;

											cGestor.map((c) => {
												totalCap += c.aCapital;
												totalIC += c.aIntCorriente;
												totalCobrado += c.totalRecibido;

												totalSeguro += c.aSeguro;

												totalAdelanto += c.adelanto;
												totalDia += c.dia + c.mora + c.vencido;
											});

											totalCobrosConsol += cGestor.length;
											totalCapConsol += totalCap;
											totalICConsol += totalIC;
											totalSeguroConsol += totalSeguro;
											totalCobradoConsol += totalCobrado;

											totalDiaConsol += totalDia;
											totalAdelantoConsol += totalAdelanto;

											return isEmpty(cGestor) ? null : (
												<Stack key={gestor.id}>
													<Stack direction="row" spacing={1}>
														<Typography
															sx={{
																color: '#2196f3',
																textAlign: 'left'
															}}
															fontSize={11}
														>
															Gestor:
														</Typography>
														<Typography
															sx={{
																textAlign: 'left'
															}}
															fontSize={11}
														>
															{gestor.fullName}
														</Typography>
													</Stack>

													<hr />
													<Stack
														direction="row"
														flex="row"
														justifyContent="space-around"
													>
														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Cobros
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{cGestor.length}
															</Typography>
														</Stack>

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Dia
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{formatCurrency(totalDia)}
															</Typography>
														</Stack>

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Adelanto
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{formatCurrency(totalAdelanto)}
															</Typography>
														</Stack>

														{isAccess(
															access,
															'VER DETALLE RECUPERACION'
														) && (
															<>
																<Stack textAlign="center">
																	<Typography
																		style={{
																			fontWeight: 'bold',
																			color: '#03a9f4',
																			fontSize: 11
																		}}
																	>
																		Total A Capital
																	</Typography>
																	<Typography
																		style={{ fontSize: 11 }}
																	>
																		{formatCurrency(totalCap)}
																	</Typography>
																</Stack>

																<Stack textAlign="center">
																	<Typography
																		style={{
																			fontWeight: 'bold',
																			color: '#03a9f4',
																			fontSize: 11
																		}}
																	>
																		Total A Int. Cnte.
																	</Typography>
																	<Typography
																		style={{ fontSize: 11 }}
																	>
																		{formatCurrency(totalIC)}
																	</Typography>
																</Stack>

																<Stack textAlign="center">
																	<Typography
																		style={{
																			fontWeight: 'bold',
																			color: '#03a9f4',
																			fontSize: 11
																		}}
																	>
																		Total A Seguro.
																	</Typography>
																	<Typography
																		style={{ fontSize: 11 }}
																	>
																		{formatCurrency(
																			totalSeguro
																		)}
																	</Typography>
																</Stack>
															</>
														)}

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Cobrado
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{formatCurrency(totalCobrado)}
															</Typography>
														</Stack>
													</Stack>
													<hr />

													<TableContainer style={{ marginBottom: 50 }}>
														<Table
															aria-label="simple table"
															size="small"
														>
															<TableHead>
																<TableRow>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		Transacción
																	</TableCell>
																	<TableCell
																		align="left"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		Cliente
																	</TableCell>

																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		#Crédito
																	</TableCell>

																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		F/H Pago
																	</TableCell>

																	{isAccess(
																		access,
																		'VER DETALLE RECUPERACION'
																	) && (
																		<>
																			<TableCell
																				align="center"
																				className="text-primary fw-bold"
																				style={{
																					fontSize: 11
																				}}
																			>
																				A Capital
																			</TableCell>
																			<TableCell
																				align="center"
																				className="text-primary fw-bold"
																				style={{
																					fontSize: 11
																				}}
																			>
																				A.Int.Corriente
																			</TableCell>
																			<TableCell
																				align="center"
																				className="text-primary fw-bold"
																				style={{
																					fontSize: 11
																				}}
																			>
																				A.Seguro
																			</TableCell>
																		</>
																	)}
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		Total Recibido
																	</TableCell>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 11 }}
																	>
																		Forma de Pago
																	</TableCell>
																</TableRow>
															</TableHead>
															<TableBody>
																{cGestor.map((row) => {
																	return (
																		<TableRow key={row.id}>
																			<TableCell
																				align="center"
																				component="th"
																				scope="row"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{row.id}
																			</TableCell>
																			<TableCell
																				align="left"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{row.cliente}
																			</TableCell>
																			<TableCell
																				align="center"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{row.creditId}
																			</TableCell>
																			<TableCell
																				align="center"
																				component="th"
																				scope="row"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{moment(
																					row.fechaPago
																				).format(
																					'DD/MM/yyyy hh:mm'
																				)}
																			</TableCell>

																			{isAccess(
																				access,
																				'VER DETALLE RECUPERACION'
																			) && (
																				<TableCell
																					align="center"
																					component="th"
																					scope="row"
																					style={{
																						fontSize: 9
																					}}
																				>
																					{formatCurrency(
																						row.aCapital
																					)}
																				</TableCell>
																			)}

																			{isAccess(
																				access,
																				'VER DETALLE RECUPERACION'
																			) && (
																				<TableCell
																					align="center"
																					component="th"
																					scope="row"
																					style={{
																						fontSize: 9
																					}}
																				>
																					{formatCurrency(
																						row.aIntCorriente
																					)}
																				</TableCell>
																			)}

																			{isAccess(
																				access,
																				'VER DETALLE RECUPERACION'
																			) && (
																				<TableCell
																					align="center"
																					component="th"
																					scope="row"
																					style={{
																						fontSize: 9
																					}}
																				>
																					{formatCurrency(
																						row.aSeguro
																					)}
																				</TableCell>
																			)}
																			<TableCell
																				align="center"
																				component="th"
																				scope="row"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{formatCurrency(
																					row.totalRecibido
																				)}
																			</TableCell>
																			<TableCell
																				align="center"
																				component="th"
																				scope="row"
																				style={{
																					fontSize: 9
																				}}
																			>
																				{row.metodoPago ===
																				2
																					? 'Transferencia'
																					: 'Efectivo'}
																			</TableCell>
																		</TableRow>
																	);
																})}
															</TableBody>
														</Table>
													</TableContainer>
												</Stack>
											);
										})}
									</Stack>
								);
							})}
						</>
					)}

					{gestorList.length === 1 ? null : (
						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center'
								}}
							>
								Consolidado
							</Typography>

							<hr />

							<Stack direction="row" flex="row" justifyContent="space-around">
								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Total Cobros
									</Typography>
									<Typography style={{ fontSize: 11 }}>
										{totalCobrosConsol}
									</Typography>
								</Stack>

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Total Dia
									</Typography>
									<Typography style={{ fontSize: 11 }}>
										{formatCurrency(totalDiaConsol)}
									</Typography>
								</Stack>

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Total Adelanto
									</Typography>
									<Typography style={{ fontSize: 11 }}>
										{formatCurrency(totalAdelantoConsol)}
									</Typography>
								</Stack>

								{isAccess(access, 'VER DETALLE RECUPERACION') && (
									<>
										<Stack textAlign="center">
											<Typography
												style={{
													fontWeight: 'bold',
													color: '#03a9f4',
													fontSize: 11
												}}
											>
												Total A Capital
											</Typography>
											<Typography style={{ fontSize: 11 }}>
												{formatCurrency(totalCapConsol)}
											</Typography>
										</Stack>

										<Stack textAlign="center">
											<Typography
												style={{
													fontWeight: 'bold',
													color: '#03a9f4',
													fontSize: 11
												}}
											>
												Total A Int. Cnte.
											</Typography>
											<Typography style={{ fontSize: 11 }}>
												{formatCurrency((totalICConsol / 100) * 99)}
											</Typography>
										</Stack>

										<Stack textAlign="center">
											<Typography
												style={{
													fontWeight: 'bold',
													color: '#03a9f4',
													fontSize: 11
												}}
											>
												Total A Seguro.
											</Typography>
											<Typography style={{ fontSize: 11 }}>
												{formatCurrency(totalSeguroConsol)}
											</Typography>
										</Stack>
									</>
								)}

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Total Cobrado
									</Typography>
									<Typography style={{ fontSize: 11 }}>
										{formatCurrency(totalCobradoConsol)}
									</Typography>
								</Stack>
							</Stack>
							<hr />
						</Stack>
					)}
				</Container>
			</Dialog>

			<ThemeProvider theme={lightTheme}>
				<div
					style={{
						display: 'none'
					}}
				>
					<PrintReport
						ref={compRef}
						titulo={'Reporte de Recuperación'}
						fecha={`Fecha: ${moment().format('L')}`}
					>
						<Container maxWidth={false} sx={{ textAlign: 'center' }}>
							<Stack direction={'row'} justifyContent="space-between">
								<Stack>
									<Typography
										sx={{
											color: '#2196f3',
											textAlign: 'left'
										}}
										fontSize={11}
									>
										Parametros:
									</Typography>
									<Typography fontSize={11} textAlign="left">
										{`Sucursal: ${
											selectedSucursal === 't' ? 'Todas' : sucursalName
										}`}
									</Typography>

									<Typography fontSize={11} textAlign="left">
										{`Gestor Seleccionado: ${
											selectedGestor === 't' ? 'Todos' : gestorName
										}`}
									</Typography>

									<Typography fontSize={11} textAlign="left">
										{`Desde: ${moment(fechaDesde).format('L')} - Hasta:  ${moment(
											fechaHasta
										).format('L')}`}
									</Typography>
								</Stack>
								<Stack>
									<Typography
										sx={{
											color: '#2196f3',
											textAlign: 'left'
										}}
										fontSize={11}
									>
										Usuario:
									</Typography>
									<Typography fontSize={11} textAlign="left">
										{user}
									</Typography>
									<Typography fontSize={11} textAlign="left">
										{rol}
									</Typography>
									<Typography fontSize={11} textAlign="left">
										{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
									</Typography>
								</Stack>
							</Stack>

							<Stack sx={{ textAlign: 'center' }}>
								<hr />
								{isEmpty(data) ? (
									<NoData />
								) : (
									<>
										{sucursalList.map((suc) => {
											const sSucursal = data.filter(
												(c) => c.sucursal === suc.description
											);

											return (
												<Stack key={suc.description}>
													<Stack direction="row" spacing={1}>
														<Typography
															sx={{
																color: '#2196f3',
																textAlign: 'left'
															}}
															fontSize={11}
														>
															Sucursal:
														</Typography>
														<Typography
															sx={{
																textAlign: 'left'
															}}
															fontSize={11}
														>
															{`${suc.description}`}
														</Typography>
													</Stack>

													{gestorList.map((gestor) => {
														const cGestor = sSucursal.filter(
															(c) => c.gestor === gestor.id
														);
														let totalCap = 0;
														let totalIC = 0;
														let totalCobrado = 0;
														let totalSeguro = 0;

														cGestor.map((c) => {
															totalCap += c.aCapital;
															totalIC += c.aIntCorriente;
															totalCobrado += c.totalRecibido;

															totalSeguro += c.aSeguro;
														});

														return isEmpty(cGestor) ? null : (
															<Stack key={gestor.id}>
																<Stack direction="row" spacing={1}>
																	<Typography
																		sx={{
																			color: '#2196f3',
																			textAlign: 'left'
																		}}
																		fontSize={11}
																	>
																		Gestor:
																	</Typography>
																	<Typography
																		sx={{
																			textAlign: 'left'
																		}}
																		fontSize={11}
																	>
																		{gestor.fullName}
																	</Typography>
																</Stack>

																<Divider />

																<TableContainer>
																	<Table
																		aria-label="simple table"
																		size="small"
																	>
																		<TableHead>
																			<TableRow>
																				<TableCell
																					align="center"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					Transacción
																				</TableCell>
																				<TableCell
																					align="left"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					Cliente
																				</TableCell>

																				<TableCell
																					align="center"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					#Crédito
																				</TableCell>

																				<TableCell
																					align="center"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					F/H Pago
																				</TableCell>

																				{isAccess(
																					access,
																					'VER DETALLE RECUPERACION'
																				) && (
																					<TableCell
																						align="center"
																						className="text-primary fw-bold"
																						style={{
																							fontSize: 10
																						}}
																					>
																						A Capital
																					</TableCell>
																				)}

																				{isAccess(
																					access,
																					'VER DETALLE RECUPERACION'
																				) && (
																					<TableCell
																						align="center"
																						className="text-primary fw-bold"
																						style={{
																							fontSize: 10
																						}}
																					>
																						A.Int.Corriente
																					</TableCell>
																				)}

																				{isAccess(
																					access,
																					'VER DETALLE RECUPERACION'
																				) && (
																					<TableCell
																						align="center"
																						className="text-primary fw-bold"
																						style={{
																							fontSize: 10
																						}}
																					>
																						A.Seguro
																					</TableCell>
																				)}
																				<TableCell
																					align="center"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					Total Recibido
																				</TableCell>
																				<TableCell
																					align="center"
																					className="text-primary fw-bold"
																					style={{
																						fontSize: 10
																					}}
																				>
																					Forma de Pago
																				</TableCell>
																			</TableRow>
																		</TableHead>
																		<TableBody>
																			{cGestor.map((row) => {
																				return (
																					<TableRow
																						key={row.id}
																					>
																						<TableCell
																							align="center"
																							component="th"
																							scope="row"
																							style={{
																								fontSize: 9
																							}}
																							className="text-dark"
																						>
																							{row.id}
																						</TableCell>
																						<TableCell
																							align="left"
																							component="th"
																							scope="row"
																							className="text-dark"
																							style={{
																								fontSize: 9
																							}}
																						>
																							{
																								row.cliente
																							}
																						</TableCell>
																						<TableCell
																							align="center"
																							component="th"
																							scope="row"
																							className="text-dark"
																							style={{
																								fontSize: 9
																							}}
																						>
																							{
																								row.creditId
																							}
																						</TableCell>
																						<TableCell
																							align="center"
																							component="th"
																							scope="row"
																							className="text-dark"
																							style={{
																								fontSize: 9
																							}}
																						>
																							{moment(
																								row.fechaPago
																							).format(
																								'DD/MM/yyyy hh:mm'
																							)}
																						</TableCell>

																						{isAccess(
																							access,
																							'VER DETALLE RECUPERACION'
																						) && (
																							<TableCell
																								align="center"
																								component="th"
																								scope="row"
																								className="text-dark"
																								style={{
																									fontSize: 9
																								}}
																							>
																								{formatCurrency(
																									row.aCapital
																								)}
																							</TableCell>
																						)}

																						{isAccess(
																							access,
																							'VER DETALLE RECUPERACION'
																						) && (
																							<TableCell
																								align="center"
																								component="th"
																								scope="row"
																								style={{
																									fontSize: 9
																								}}
																								className="text-dark"
																							>
																								{formatCurrency(
																									row.aIntCorriente
																								)}
																							</TableCell>
																						)}

																						{isAccess(
																							access,
																							'VER DETALLE RECUPERACION'
																						) && (
																							<TableCell
																								align="center"
																								component="th"
																								scope="row"
																								style={{
																									fontSize: 9
																								}}
																								className="text-dark"
																							>
																								{formatCurrency(
																									row.aSeguro
																								)}
																							</TableCell>
																						)}
																						<TableCell
																							align="center"
																							component="th"
																							scope="row"
																							style={{
																								fontSize: 9
																							}}
																							className="text-dark"
																						>
																							{formatCurrency(
																								row.totalRecibido
																							)}
																						</TableCell>
																						<TableCell
																							align="center"
																							component="th"
																							scope="row"
																							className="text-dark"
																						>
																							{row.metodoPago ===
																							2
																								? 'TRANSFERENCIA'
																								: 'EFECTIVO'}
																						</TableCell>
																					</TableRow>
																				);
																			})}
																		</TableBody>
																	</Table>
																</TableContainer>

																<hr />
																<Stack
																	direction="row"
																	flex="row"
																	justifyContent="space-around"
																>
																	<Stack textAlign="center">
																		<Typography
																			style={{
																				fontWeight: 'bold',
																				color: '#03a9f4',
																				fontSize: 11
																			}}
																		>
																			Total Cobros
																		</Typography>
																		<Typography
																			style={{ fontSize: 11 }}
																		>
																			{cGestor.length}
																		</Typography>
																	</Stack>

																	{isAccess(
																		access,
																		'VER DETALLE RECUPERACION'
																	) && (
																		<>
																			<Stack textAlign="center">
																				<Typography
																					style={{
																						fontWeight:
																							'bold',
																						color: '#03a9f4',
																						fontSize: 11
																					}}
																				>
																					Total A Capital
																				</Typography>
																				<Typography
																					style={{
																						fontSize: 11
																					}}
																				>
																					{formatCurrency(
																						totalCap
																					)}
																				</Typography>
																			</Stack>

																			<Stack textAlign="center">
																				<Typography
																					style={{
																						fontWeight:
																							'bold',
																						color: '#03a9f4',
																						fontSize: 11
																					}}
																				>
																					Total A Int.
																					Cnte.
																				</Typography>
																				<Typography
																					style={{
																						fontSize: 11
																					}}
																				>
																					{formatCurrency(
																						totalIC
																					)}
																				</Typography>
																			</Stack>

																			<Stack textAlign="center">
																				<Typography
																					style={{
																						fontWeight:
																							'bold',
																						color: '#03a9f4',
																						fontSize: 11
																					}}
																				>
																					Total A Seguro.
																				</Typography>
																				<Typography
																					style={{
																						fontSize: 11
																					}}
																				>
																					{formatCurrency(
																						totalSeguro
																					)}
																				</Typography>
																			</Stack>
																		</>
																	)}

																	<Stack textAlign="center">
																		<Typography
																			style={{
																				fontWeight: 'bold',
																				color: '#03a9f4',
																				fontSize: 11
																			}}
																		>
																			Total Cobrado
																		</Typography>
																		<Typography
																			style={{ fontSize: 11 }}
																		>
																			{formatCurrency(
																				totalCobrado
																			)}
																		</Typography>
																	</Stack>
																</Stack>
																<hr />
															</Stack>
														);
													})}
												</Stack>
											);
										})}
									</>
								)}

								{gestorList.length === 1 ? null : (
									<Stack>
										<Typography
											sx={{
												color: '#2196f3',
												textAlign: 'center'
											}}
										>
											Consolidado
										</Typography>

										<hr />

										<Stack
											direction="row"
											flex="row"
											justifyContent="space-around"
										>
											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Cobros
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalCobrosConsol}
												</Typography>
											</Stack>

											{isAccess(access, 'VER DETALLE RECUPERACION') && (
												<>
													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total A Capital
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{formatCurrency(totalCapConsol)}
														</Typography>
													</Stack>

													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total A Int. Cnte.
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{formatCurrency(totalICConsol)}
														</Typography>
													</Stack>

													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total A Seguro.
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{formatCurrency(totalSeguroConsol)}
														</Typography>
													</Stack>
												</>
											)}

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Cobrado
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{formatCurrency(totalCobradoConsol)}
												</Typography>
											</Stack>
										</Stack>
										<hr />
									</Stack>
								)}
							</Stack>
						</Container>
					</PrintReport>
				</div>
			</ThemeProvider>
		</div>
	);
};

export default Recuperacion;
